export class SortInfo {
    sortField: string;
    sortAscending: boolean;
}
